import { render } from "./Admincenter.vue?vue&type=template&id=05308a94"
import script from "./Admincenter.vue?vue&type=script&lang=js"
export * from "./Admincenter.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__